import 'babel-polyfill';
import 'raf/polyfill';
import 'lodash';
import { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import 'pf-core/index.css';
import { areCookiesAvailable } from './utilities/checkCookie';
import { RedirectToLogin } from './features/Redirect/index';
import { Loader } from './components/FullScreenLoader/Loader';
// Popper js is required by reactstrap
import 'popper.js/dist/umd/popper';
import globals from './utilities/globals';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  ArcElement,
  Filler,
  RadialLinearScale,
  Title,
  Tooltip,
  Legend,
  DoughnutController
} from 'chart.js';
import { MatrixController, MatrixElement } from 'chartjs-chart-matrix';

// Custom SunburstController for Sunburst charts
class SunburstController extends DoughnutController {
  draw () {
    super.draw();

    const { ctx, chartArea, data } = this.chart;
    const meta = this.getMeta();
    const total = data.datasets[0].data.reduce((a, b) => a + b, 0);

    ctx.save();
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillStyle = '#323232';
    ctx.font = '10px \'Open Sans\'';

    meta.data.forEach((arc, idx) => {
      const { startAngle, endAngle, innerRadius, outerRadius } = arc;
      const midAngle = (startAngle + endAngle) / 2;
      const radius = (innerRadius + outerRadius) / 2;

      const x =
        (chartArea.left + chartArea.right) / 2 + Math.cos(midAngle) * radius;
      const y =
        (chartArea.top + chartArea.bottom) / 2 + Math.sin(midAngle) * radius;

      const val = data.datasets[0].data[idx];
      if (!val) {
        return;
      }

      const pct = ((val / total) * 100).toFixed(2) + '%';

      if (endAngle - startAngle < 0.2) {
        return;
      }

      ctx.fillText(pct, x, y);
    });

    ctx.restore();
  }
}
SunburstController.id = 'sunburst';
SunburstController.defaults = DoughnutController.defaults;

// Register all Chart.js components globally
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  ArcElement,
  Filler,
  RadialLinearScale,
  Title,
  Tooltip,
  Legend,
  MatrixController,
  MatrixElement,
  SunburstController
);

globals();
const StudioApplication = lazy(() => import('./features/App'));

function App () {
  if (!areCookiesAvailable()) {
    return <RedirectToLogin />;
  }
  return (
    <Suspense fallback={<Loader type="fullScreen" />}>
      <StudioApplication />
    </Suspense>
  );
}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);
